import React from 'react'

export interface ChannelDetailSpecProps {
  title?: string
  value?: string
}

export const ChannelDetailSpec: React.FC<ChannelDetailSpecProps> = ({
  title,
  value,
}) => {
  return (
    <div>
      {title && (
        <span className="is-size-7 has-text-grey ml-1" style={{ fontSize: 14 }}>
          <b>{title}</b>
        </span>
      )}{' '}
      {value && (
        <span className="has-text-black ml-2" style={{ fontSize: 14 }}>
          {value}
        </span>
      )}
    </div>
  )
}
